module.exports = __webpack_public_path__ + "img/quickclick.e5364dc2.png";